import React, { useEffect } from "react";
import { Drawer, Form, Input, Button } from "antd";

const CreateDrinkCat = ({ open, onClose, onSubmit, initialValues }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [initialValues, open, form]);

  const handleFinish = (values) => {
    onSubmit(values);
  };

  return (
    <Drawer
      title={initialValues ? "Edit Drinks Category" : "Create Drinks Category"}
      width={420}
      open={open}
      onClose={onClose}
      destroyOnClose
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleFinish}
        onValuesChange={(changedValues) => {
          if (changedValues.name !== undefined) {
            form.setFieldsValue({
              code: changedValues.name
                ?.toLowerCase()
                .trim()
                .replace(/\s+/g, "_"),
            });
          }
        }}
      >
        <div className="page-card table-card">
          <div className="table-card-header">
            <div>
              <h3>{initialValues ? "Update Drinks Category" : "Create Drinks Category"}</h3>
              <p>Fill the details below to save the drinks category.</p>
            </div>
          </div>

          <Form.Item
            label="Drinks Category Name"
            name="name"
            rules={[{ required: true, message: "Please enter drinks category name" }]}
          >
            <Input placeholder="Enter drinks category name" />
          </Form.Item>

          <div className="form-actions">
            <Button className="secondary-btn" onClick={onClose}>
              Cancel
            </Button>
            <Button type="primary" htmlType="submit" className="primary-btn">
              {initialValues ? "Update Category" : "Save Category"}
            </Button>
          </div>
        </div>
      </Form>
    </Drawer>
  );
};

export default CreateDrinkCat;